import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import bg1 from '../assets/img/jiankang_geren_icon.png';
import bg2 from '../assets/img/yajiankang_geren_icon.png';
import bg3 from '../assets/img/jibing_geren_icon.png';
import gaugeImg from '../assets/img/indicator-cut.png';
import cursorImgGreen from '../assets/img/indicator-cursor-green.png';
import cursorImgOrange from '../assets/img/indicator-cursor-orange.png';
import cursorImgRed from '../assets/img/indicator-cursor-red.png';

import { scoreToStatusText } from './util';
import { queryObject } from '../util';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 312px;
  background-size: fill;
  padding-top: 32px;
`;
const Gauge = styled.div`
  position: relative;
  margin: 0 auto;
  text-align: center;
`;

const CursorWrapper = styled.div`
  position: absolute;
  height: 20px; 
  width: ${325.1 + 10}px;   /* width of gauge plus radius of cursor 10px */
  text-align: left;
  /* move to gauge center, minus radius of cursor 10px */
  left: calc(50% - ${(325.1 + 10) / 2}px);
  bottom: ${64 - 10}px;
  transform: rotate(-20deg); /* -20deg ~ 200deg */
`;

const scoreToImage = (score) => {
  if (score < 40) {
    return cursorImgRed;
  } else if (score < 81) {
    return cursorImgOrange;
  }
  return cursorImgGreen;
};

const Cursor = ({ score }) => (
  <CursorWrapper style={{
    transform: `rotate(${(score * 2.2) - 20}deg)`,
    '-webkit-transform': `rotate(${(score * 2.2) - 20}deg)`
  }}>
    <img src={scoreToImage(score)} alt='cursor' style={{ height: '20px', width: '20px' }} />
  </CursorWrapper>
);

Cursor.propTypes = {
  score: PropTypes.number.isRequired,
};

const LabelGroup = styled.div`
  position: absolute;
  width: 100%;
  bottom: 55px;
  
  h1, h2, h3 {
    color: white;
    text-align: center;
    line-height: 1;
    margin: 0;
    font-weight: normal;
  }
  
  h1 {
    font-size: 47px;
    margin: 20px auto;
    
    small {
      font-size: 30px;
    }
  }
  
  h2 {
    font-size: 33px;
  }
  
  h3 {
      font-size: 24px;
  }
`;

const Number = styled.div`
  position: absolute;
  bottom: 55px;
  font-size: 21px;
  color: white;
`;


class Indicator extends Component {
  render() {
    let { score } = this.props;
    const status = scoreToStatusText(score);
    const isXSD = queryObject().source === 'xsd';
    if (isXSD) score = Math.ceil(score / 5) * 5;
    return (
      <Container style={score>80? {background:"url("+bg1+")"}:score<40?{background:"url("+bg3+")"}:{background:"url("+bg2+")"}}>
        <Gauge>
          <img style={{ height: '223px' }} src={gaugeImg} alt='gauge' />
          {isXSD ? null : <Cursor score={score} />}
        </Gauge>
        <LabelGroup>
          {isXSD ? null : <h3>健康指数</h3>}
          {isXSD ? null : <h1>{score}<small>分</small></h1>}
          {isXSD ? <h1 style={{ marginBottom: '48px' }}>{status}</h1> : <h2>{status}</h2>}
        </LabelGroup>
        {isXSD ? null : <Number style={{ left: '193px' }}>0</Number> }
        {isXSD ? null : <Number style={{ right: '170px' }}>100</Number> }
      </Container>
    );
  }
}

Indicator.propTypes = {
  score: PropTypes.number.isRequired,
};
Indicator.defaultProps = {};

export default Indicator;



// WEBPACK FOOTER //
// ./src/components/indicator.jsx